/**
 * Safe BPMN ordering provider that handles null newParent when dragging pools
 * from the palette. The default BpmnOrderingProvider throws "Cannot read
 * properties of null (reading 'children')" in getOrdering when newParent is null.
 */
import inherits from 'inherits-browser';
import BpmnOrderingProvider from 'bpmn-js/lib/features/ordering/BpmnOrderingProvider';

function SafeBpmnOrderingProvider(
  this: any,
  eventBus: any,
  canvas: any
) {
  BpmnOrderingProvider.call(this, eventBus, canvas);

  const originalGetOrdering = this.getOrdering.bind(this);

  this.getOrdering = function (element: any, newParent: any) {
    // Fix: when dragging a pool from the palette, newParent can be null.
    // Use root element as fallback to avoid "Cannot read properties of null (reading 'children')".
    if (!newParent) {
      newParent = canvas.getRootElement();
    }
    if (!newParent?.children) {
      return { parent: newParent, index: 0 };
    }
    return originalGetOrdering(element, newParent);
  };
}

(SafeBpmnOrderingProvider as any).$inject = ['eventBus', 'canvas'];
inherits(SafeBpmnOrderingProvider, BpmnOrderingProvider);

const safeBpmnOrderingProviderModule = {
  bpmnOrderingProvider: ['type', SafeBpmnOrderingProvider],
};
export default safeBpmnOrderingProviderModule;
